import 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import _Tooltip from 'reakit/Tooltip';
var Tooltip = styled(_Tooltip).withConfig({
  displayName: "styled__Tooltip",
  componentId: "sc-8zl4l2-0"
})(["background:black;border-radius:2px;color:white;opacity:0.8;hyphens:auto;font-size:", "rem;font-weight:", ";padding:", "rem ", "rem;&{", ";}"], theme('fannypack.fontSizes.100'), theme('fannypack.fontWeights.normal'), space(1), space(2), theme('fannypack.Tooltip.base'));
export default Tooltip;
export { Tooltip };